import React from "react";
import { AlignLeft } from "lucide-react";

export default function IntroCard({ intro }) {
  return (
    <div className="border-2 border-blue-200 rounded-2xl p-5 bg-blue-50/40">
      {/* Section label */}
      <div className="flex items-center gap-2 mb-3">
        <AlignLeft size={16} className="text-blue-500" />
        <span className="text-sm font-semibold text-blue-700">引入</span>
      </div>

      {/* Overview */}
      <p className="text-sm text-gray-700 leading-relaxed mb-1">
        {intro.overview}
        <strong className="text-gray-900">{intro.highlight}</strong>
      </p>
      <p className="text-sm text-gray-600 leading-relaxed mb-4">{intro.sub}</p>

      {/* Logic chain */}
      <p className="text-sm font-medium text-gray-700 mb-2">逻辑链条：</p>
      <ul className="space-y-1.5">
        {intro.logicChain.map((item, i) => (
          <li key={i} className="flex items-start gap-2 text-sm text-gray-600">
            <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-blue-400 shrink-0" />
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
}
